import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Routes, Route } from 'react-router-dom';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';
import ErrorView from '~common/components/error-view';
import { APIError } from '~common/lib/types';
import JsonLabel from '../../../../../common/ui/components/json-label';
import URLManager from '~common/lib/url-manager';
import * as request from 'superagent';
import LoadingView from '~common/components/loading-view';
import {setValueAtPath} from '~common/form/helper';




const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
	userId: any;
}

type State = {
	status: "loading" | "ready"
	data: any;
	form: any;
	definitions: Array<any>;
	error?: any;
};

class UserEditor extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			data: {},
			form: {},
			definitions: [],
			status: "loading"
		};
	}

	
	handleErrorClose = () => {
		this.setState({error:null})
	  }

	componentDidMount() {
		// ATTENTION: DO NOT ALLOW A USER TO ADMIN THEIR OWN.
		// console.log("user ID", this.props.userId)
		// console.log("Window ID", (window as any).App.userContext.id)
		
		if (this.props.userId == (window as any).App.userContext.id) {
			const apiErr = new APIError()
			apiErr.type = "system"
			apiErr.message = "You Cannot Admin Your Own User, Redirecting to User Preferences"
			this.setState({error: apiErr})
			setTimeout(()=>{
				window.location.href = "/preferences"
			}, 3000)
			return
		} else {
			var promises: Array<any> = [
				request.get('/api/form-definitions/select?selector='+URLManager.getQueryStringValue({"formType": "userEditor", "modules": "users", "userType": "Any"})),
				request.get(`/api/portal-users/editor/${this.props.userId}`)
			];
			Promise.all(promises).then((values: Array<request.Response>)=>{
				// console.log("values", values)
				this.setState({
					status: "ready",
					form: values[0].body,
					definitions: values[0].body.definitions,
					data: values[1].body
				})
			}).catch((err)=>{
				const apiErr = new APIError()
				apiErr.type = "http"
				apiErr.message = (err.response || { text: err.toString() }).text
				this.setState({
					error: apiErr
				})
			})
		}
	}

	// handleChangeAtPath is used to ferry changes from owned components upstream
	handleChangeAtPath = (path: string, value: any) => {
		// console.log("user edit handle change at path")
		let {data} = this.state;
	
		let svpResp = setValueAtPath(path, data, value);
		data = svpResp.data;
	
		if (svpResp.err) {
		  console.error(svpResp.err);
		}
	
		// Save the data and then show the user progress against errors
		this.setState({data});
	};

	render() {

    const {match} = this.props;
		const { classes }: { classes: ClassNameMap } = this.props;
		const {error} = this.state;
		var {status, data, form, definitions} = this.state

		// TODO: BD, add separate render case if ID is user ID to render a warning page and a link to user pref
		var errorView: any = null;
		if (error) {
			errorView = <ErrorView onClose={this.handleErrorClose} classes={{}} error={error.toString()} />;
		}

		// append user type to query so that internal groups don't get assigned to vendor users, and vice versa.
		if (form.definitions) {
			var groupsDef = form.definitions.find((d: any)=>{return d.key == "groupInfo"})
			if (groupsDef && data && data.userInfo && data.userInfo.userType) {
				groupsDef.predefined.forEach((pdf: any)=>{
					if (pdf.key == "groupRelations") {
						pdf.appendToQuery = [
							{
								key: "restrictToUserType",
								value: data.userInfo.userType
							}
						]
					}
				})
			}
		}

		var criteria = URLManager.getQueryString(window.location.href)
		
		switch(status) {
			case "loading":
				return <div>{errorView}<LoadingView classes={{}} /></div>
			case "ready":
				return (
					<div className={classes.container}>
					{errorView}
					<FormBasedEditor 
						history={this.props.history} 
						match={match}
						data={data}
						onChangeAtPath={this.handleChangeAtPath}
						form={form}
						clearDataOnSubmit={false}
						customRenderers={{"JsonLabel":JsonLabel}}
						dataUrl="/api/portal-users/editor"
						successMessage="User Successfully Saved"
						formSelector={{"formType": "userEditor", "modules": "users", "userType": "Any"}}
						redirectUrl={`/users/admin?q=${URLManager.getQueryStringValue(criteria)}`}
					>
					</FormBasedEditor>
					</div>
				);
		}
		
		
	}
}

export default withStyles(styles)(UserEditor);
